// extracted by mini-css-extract-plugin
export default {"Box":"RulesetFilter-module__Box--p0_a7"};